<template>
  <div>
    <vs-popup :title="$t('OperatorChoice')" :active.sync="showModal">
      <choice-operator-popup
        :showUserList="onShowChoiceOperatorPopup"
        @onSelectOperator="onSelectOperator"
        @finish="onfinish"
      ></choice-operator-popup>
      <choice-transport-popup
        :showUserList="onShowChoiceTransportPopup"
        @onSelectTransport="onSelectTransport"
        @finish="onfinish"
      ></choice-transport-popup>
      <div>
        <div class="vx-row mb-2">
          <div class="vx-row lg:w-6/12 w-full mb-2 mx-0">
            <div class="vx-col p-0 w-full ml-3">
              <template v-if="onOperatorChice">
                <div class="vx-row m-8" v-if="DataPackageCurrent.operatorInfo">
                  {{ $t("OperatorFullName") }}
                  <span class="text-success">{{
                    ` : ${DataPackageCurrent.operatorInfo.firstName} ${DataPackageCurrent.operatorInfo.lastName}`
                  }}</span>
                  <vs-button
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    size="small"
                    class="bg_l_blue mr-8"
                    @click.prevent="selectOperator()"
                  ></vs-button>
                </div>
                <vs-button
                  v-else
                  class="mt-4 w-full"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  @click.prevent="selectOperator()"
                  >{{ $t("OperatorChoice") }}</vs-button
                >
              </template>

              <div v-else class="vx-row m-8">
                {{ $t("OperatorFullName") }}
                <span class="text-success">{{
                  ` : ${fullNameOperator.firstName} ${fullNameOperator.lastName}`
                }}</span>
                <vs-button
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="small"
                  class="bg_l_blue mr-8"
                  @click.prevent="selectOperator()"
                ></vs-button>
              </div>
            </div>
          </div>
          <div class="vx-row lg:w-6/12 w-full mb-2">
            <div class="vx-col w-full px-5 ml-3">
              <template v-if="onTransportChice">
                <div
                  class="vx-row my-8"
                  v-if="DataPackageCurrent.transportInfo"
                >
                  {{ $t("TransportFullName") }}
                  <span class="text-success">{{
                    ` : ${
                      DataPackageCurrent.transportInfo.transportDiscriminator ==
                      "Truck"
                        ? "وانت"
                        : "موتورسیکلت"
                    } مدل ${DataPackageCurrent.transportInfo.model} - پلاک ${
                      DataPackageCurrent.transportInfo.plate
                    }`
                  }}</span>
                  <vs-button
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    size="small"
                    class="bg_l_blue mr-6"
                    @click.prevent="selectTransport()"
                  ></vs-button>
                </div>
                <vs-button
                  v-else
                  class="mt-4 w-full"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  @click.prevent="selectTransport()"
                  >{{ $t("ToolTransportChoice") }}</vs-button
                >
              </template>
              <div v-else class="vx-row my-8">
                {{ $t("TransportFullName") }}
                <span class="text-success">{{
                  ` :  ${fullNameTransport.transportDiscriminator} مدل ${fullNameTransport.model} - پلاک ${fullNameTransport.plate}`
                }}</span>
                <vs-button
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="small"
                  class="bg_l_blue mr-6"
                  @click.prevent="selectTransport()"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
        <span v-if="showErr" class="text-danger mt-8">
          <div v-if="onOperatorChice && !DataPackageCurrent.operatorInfo">
            {{ `لطفا ${$t("Operator")} را وارد کنید.` }}
          </div>
          <div v-if="onTransportChice && DataPackageCurrent.transportInfo">
            {{ `لطفا ${$t("Transport")} را وارد کنید.` }}
          </div>
        </span>
        <vs-button
          type="filled"
          class="float-right m-6"
          @click.prevent="linkOperatorToPackage"
          v-has-permission="permission294"
          >{{ $t("Save") }}</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ChoiceOperatorPopup from "./ChoiceOperatorPopup.vue";
import ChoiceTransportPopup from "./ChoiceTransportPopup.vue";

export default {
  name: "saleManagement_BasicDefinitions_SalesPartnerPlan_NewCreatePlan",
  props: {
    show: { default: false },
    DataPackageCurrent: {},
  },
  components: {
    DataGrid,
    ChoiceOperatorPopup,
    ChoiceTransportPopup,
  },
  data() {
    return {
      permission294: "AssignOperatorToPackage",
      showErr: false,
      onShowChoiceOperatorPopup: false,
      onShowChoiceTransportPopup: false,
      onOperatorChice: true,
      onTransportChice: true,
      gridDataSource: { data: [] },
      gridDataSource1: { data: [] },
      fullNameOperator: {},
      fullNameTransport: {},
      model: {
        packageId: "",
        operatorId: "",
        transportId: "",
      },
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
        this.onOperatorChice = true;
        this.onTransportChice = true;
      },
    },
  },
  methods: {
    ...mapActions({
      assignOperatorToPackage: "shipping/assignOperatorToPackage",
    }),
    onSelectOperator(dataNewOperator) {
      this.onOperatorChice = false;
      this.fullNameOperator = dataNewOperator;
      this.model.operatorId = dataNewOperator.id;
    },
    onSelectTransport(fullTransport) {
      this.onTransportChice = false;
      this.fullNameTransport = fullTransport;
      this.fullNameTransport.transportDiscriminator =
        fullTransport.transportDiscriminator === "Truck"
          ? "وانت"
          : "موتورسیکلت";
      this.model.transportId = fullTransport.id;
    },
    selectOperator() {
      this.onShowChoiceOperatorPopup = true;
    },
    selectTransport() {
      this.onShowChoiceTransportPopup = true;
    },
    linkOperatorToPackage() {
      if (
        (this.DataPackageCurrent.transportInfo || this.model.transportId) &&
        (this.DataPackageCurrent.operatorInfo || this.model.operatorId)
      ) {
        this.model.packageId = this.DataPackageCurrent.id;
        if (!this.model.operatorId) {
          this.model.operatorId = this.DataPackageCurrent.operatorInfo.id;
        }
        if (!this.model.transportId) {
          this.model.transportId = this.DataPackageCurrent.transportInfo.id;
        }
        this.assignOperatorToPackage(this.model).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "مرسوله موردنظر به اپراتور تحویل داده شد",
            showConfirmButton: false,
            timer: 2000,
          });
        });
        setTimeout(() => {
          this.$emit("finish");
          this.onOperatorChice = true;
          this.onTransportChice = true;
        }, 3000);
      } else {
        this.showErr = true;
      }
    },
    onfinish() {
      this.onShowChoiceOperatorPopup = false;
      this.onShowChoiceTransportPopup = false;
    },
  },
};
</script>
